module.exports = __webpack_public_path__ + "img/footer-bg_tab.a247b67.webp";